import React from "react";
import ReactGA from "react-ga";
import styles from "./explore.module.scss";
import { useIsMobile } from "../../hooks/mobile.js";

import FilterAndSearch from "../filter-and-search/filter-and-search";
import Bubbles from "../bubbles/bubbles";
import List from "../list/list";
import Download from "../download/download";

ReactGA.initialize("UA-11963560-5");

export default function Explore(props) {
    const isMobile = useIsMobile();
    const {
        themes,
        opportunities,
        topics,
        searchOptions,
        filteredOpportunities,
        filteredTopics,
        handleTopicFilter,
        handleKeywordFilter,
        handleThemeFilter,
        handleSubThemeFilter,
        handleReset,
        handleOpportunitySearch,
        handleOpportunityInput,
        handleOpportunitySearchReset,
        topicFilterState,
        keywordFilterState,
        searchFilterState,
        themeFilterState,
        subThemeFilterState,
        selectedOpportunity,
        opportunitySearch,
        handleToggleView,
        view,
        handleHideCompleted,
        hideCompleted,
        completed,
        handleScrollToTop,
    } = props;

    const opportunitiesRef = React.useRef(null);
    const handleScrollToOpportunities = () => {
        opportunitiesRef.current.scrollIntoView();
        ReactGA.event({
            category: "SCIKNOW: explore",
            action: "scroll to opportunities",
        });
    };

    return (
        <div className={styles.explore} id="science-knowledge-needs-explore">
            <h2>Explore opportunities</h2>
            {themes && opportunities && topics && filteredOpportunities && filteredTopics && (
                <React.Fragment>
                    <FilterAndSearch
                        themes={themes}
                        handleTopicFilter={handleTopicFilter}
                        handleKeywordFilter={handleKeywordFilter}
                        handleThemeFilter={handleThemeFilter}
                        handleSubThemeFilter={handleSubThemeFilter}
                        handleReset={handleReset}
                        searchOptions={searchOptions}
                        handleOpportunitySearch={handleOpportunitySearch}
                        handleOpportunityInput={handleOpportunityInput}
                        handleOpportunitySearchReset={handleOpportunitySearchReset}
                        topicFilterState={topicFilterState}
                        keywordFilterState={keywordFilterState}
                        searchFilterState={searchFilterState}
                        themeFilterState={themeFilterState}
                        subThemeFilterState={subThemeFilterState}
                        opportunitySearch={opportunitySearch}
                    />
                    {isMobile && (
                        <div className={styles.bubbleListToggle}>
                            <button
                                data-active={view === "bubbles" ? "active" : "inactive"}
                                onClick={() => handleToggleView("bubbles")}
                            >
                                Bubble view
                            </button>
                            <button
                                data-active={view === "list" ? "active" : "inactive"}
                                onClick={() => handleToggleView("list")}
                            >
                                List view
                            </button>
                        </div>
                    )}
                    {(!isMobile || view === "bubbles") && (
                        <Bubbles
                            themes={themes}
                            opportunities={opportunities}
                            filteredOpportunities={filteredOpportunities}
                            topics={topics}
                            handleTopicFilter={handleTopicFilter}
                            handleScrollToOpportunities={handleScrollToOpportunities}
                            handleReset={handleReset}
                            handleHideCompleted={handleHideCompleted}
                            hideCompleted={hideCompleted}
                            completed={completed}
                        />
                    )}
                    {(!isMobile || view === "list") && (
                        <div ref={opportunitiesRef}>
                            {filteredOpportunities.length > 0 && (
                                <List
                                    themes={themes}
                                    opportunities={opportunities}
                                    filteredOpportunities={filteredOpportunities}
                                    topics={filteredTopics}
                                    handleReset={handleReset}
                                    selectedOpportunity={selectedOpportunity}
                                    handleHideCompleted={handleHideCompleted}
                                    hideCompleted={hideCompleted}
                                    completed={completed}
                                    handleScrollToTop={handleScrollToTop}
                                />
                            )}
                        </div>
                    )}
                    {isMobile && <Download />}
                </React.Fragment>
            )}
        </div>
    );
}
